import React, { useState } from 'react';
import Header from './components/Header';
import EmailVerification from './components/EmailVerification';
import OTPVerification from './components/OTPVerification';
import PersonalInformation from './components/PersonalInformation';
import ThankYouPage from './components/ThankYouPage'; 
import { useTranslation } from 'react-i18next';
import Footer from './components/Footer';
import './App.css'; 
const App = () => {
  const { i18n } = useTranslation();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [language, setLang] = useState('');
  const [token, setToken] = useState(''); 
const [activeLang, setActiveLang] = useState("en")
  const changeLanguage = (lng) => {
    setActiveLang(lng)
    i18n.changeLanguage(lng);
  };

  const handleNextStep = ( email,language) => {
    setEmail(email);
    setLang(language);
    console.log(language)
    setStep(step + 1);
  };

  const handleTokenReceived = (token) => {
    setToken(token);
    setStep(3);
  };
console.log(step)
  return (
    <>
    <div style={{ backgroundColor: 'var(--mint-green-2)', minHeight: '94vh' }}>
       {step !== 4 && <Header changeLanguage={changeLanguage} />}
       <main>
        <div style={{ color: 'var(--ocean-teal)', paddingBottom: "20px" }}>
          {step === 1 && <EmailVerification onNext={handleNextStep} />}
          {step === 2 && <OTPVerification email={email} language={language} onVerified={handleTokenReceived} />}
          {step === 3 && <PersonalInformation email={email} language={language} activeLang={activeLang} token={token} onNext={() => setStep(4)} />}
          {step === 4 && <ThankYouPage />}
        </div>
      </main>
    </div>
      <Footer /> 
    </>
  );
};

export default App;
